/**
 * 正規化座標(ADR-0013 論点 2)。
 *
 * 頂点座標は 0.0〜1.0 の比率で保持し、小数第 6 位に丸める。
 * キャンバス解像度が変わっても座標が壊れないことを優先した設計で、
 * 解像度の変更時に再計算は不要。
 *
 * 正本: docs/issues/28-data-design/DESIGN.md の `project.json` スキーマ。
 */
/** 座標の丸め桁数。1920px 換算で約 0.002px の精度。 */
export const COORDINATE_PRECISION = 6;
const FACTOR = 10 ** COORDINATE_PRECISION;
/**
 * 正規化座標を小数第 6 位に丸める。
 *
 * 保存時に丸めることで、桁が揺れて無意味な差分が出るのを防ぐ。
 * キャンバスの外に出る頂点は許容するため、範囲でのクランプは行わない
 * (負値・1.0 超もありうる — #28 DESIGN.md)。
 */
export function roundCoordinate(value) {
    if (!Number.isFinite(value)) {
        throw new RangeError(`座標に有限数以外は指定できません: ${value}`);
    }
    // 0 との加算は -0 を 0 に正規化するため。JSON 上で "-0" が出ると差分が出る。
    return Math.round(value * FACTOR) / FACTOR + 0;
}
/** 点を丸める。 */
export function roundPoint(point) {
    return [roundCoordinate(point[0]), roundCoordinate(point[1])];
}
/** 点の配列を丸める。 */
export function roundPoints(points) {
    return points.map(roundPoint);
}
/**
 * 座標がキャンバスの内側にあるか。
 *
 * 外側でも保存は許容されるため、これは検証ではなく UI の判断に使う
 * (ハンドルが画面外に出ないよう余白を取るなど)。
 */
export function isInsideCanvas(point) {
    const [x, y] = point;
    return x >= 0 && x <= 1 && y >= 0 && y <= 1;
}
/** 正規化座標を表示座標(px)に変換する。 */
export function toDisplay(point, size) {
    return { x: point[0] * size.width, y: point[1] * size.height };
}
/**
 * 表示座標(px)を正規化座標に変換して丸める。
 *
 * 幅・高さが 0 のときは 0 除算になるため呼び出し側で除外する。
 */
export function fromDisplay(position, size) {
    if (size.width <= 0 || size.height <= 0) {
        throw new RangeError(`表示サイズが不正です: ${size.width}x${size.height}`);
    }
    return roundPoint([position.x / size.width, position.y / size.height]);
}
//# sourceMappingURL=coordinate.js.map